module.exports = __webpack_public_path__ + "img/icon-notification-green.275d7004.svg";